import React, { useEffect, useState } from 'react'
import AWS from 'aws-sdk';
import { toast } from 'react-toastify'
import { ProductIcon } from '../../Assets/AllSvg';

const S3_BUCKET = process.env.REACT_APP_IMAGE_S3_BUCKET;
const APP_ACCESS_KEY = process.env.REACT_APP_ACCESS_KEY;
const APP_SCRET_KEY = process.env.REACT_APP_SCRET_KEY;

const ProductImage = ({product}) => {
    const [file, setFile] = useState('')

    const getImage = () => {
        AWS.config.update({
            accessKeyId: APP_ACCESS_KEY,
            secretAccessKey: APP_SCRET_KEY,
            region: process.env.REACT_APP_REGION,
        });
    
        const s3 = new AWS.S3();
        const params = {
            Bucket: S3_BUCKET,
            Prefix: `${product.user_id}/${product.product_id}/`,
        };
    
        s3.listObjectsV2(params, (err, data) => {
            if (err) {
                toast.error(err, { autoClose: 5000 });
            } else {
                const urls = data.Contents.map((object) => {
                    return `https://${S3_BUCKET}.s3.${AWS.config.region}.amazonaws.com/${object.Key}`;
                });
                urls[0] ? setFile(urls[0]) : setFile('')
            }
        });
    }

    useEffect(() => {
      getImage()
    }, [])
    
  return (
    file
        ? <img src={file} alt='' className='w-[40px] object-cover'/>
        : <ProductIcon className="fill-gray-400 sm:w-[40px] w-[40px] sm:h-[40px] h-[40px] p-[12px] rounded-md shadow-[0_0_0_1px_rgb(235,238,241)]" />
  )
}

export default ProductImage
